"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logEventDurationMetric = exports.endEventTimer = exports.startEventTimer = void 0;
var consts_1 = require("../../consts");
var __1 = require("..");
var eventDurationLogger_const_1 = require("./eventDurationLogger.const");
var startEventTimer = function (eventName) {
    performance.mark("".concat(eventName).concat(eventDurationLogger_const_1.EVENT_START_SUFFIX));
};
exports.startEventTimer = startEventTimer;
var endEventTimer = function (eventName) {
    performance.mark("".concat(eventName).concat(eventDurationLogger_const_1.EVENT_END_SUFFIX));
};
exports.endEventTimer = endEventTimer;
/**
 * Logs a duration/time(in milliseconds) metric for events
 */
var logEventDurationMetric = function (eventMetricName, pageName, isGqlInvoked) {
    var _a;
    try {
        performance.measure(eventMetricName, "".concat(eventMetricName).concat(eventDurationLogger_const_1.EVENT_START_SUFFIX), "".concat(eventMetricName).concat(eventDurationLogger_const_1.EVENT_END_SUFFIX));
        __1.logger.emitLatencyMetric({
            metricName: eventMetricName,
            metricValue: performance.getEntriesByName(eventMetricName)[0].duration,
            dimensions: (_a = {},
                _a[consts_1.DIMENSION_NAME.PAGE_NAME] = pageName,
                _a[consts_1.DIMENSION_NAME.IS_GQL_INVOKED] = isGqlInvoked ? 'true' : 'false',
                _a)
        });
        performance.clearMeasures(eventMetricName);
        performance.clearMarks("".concat(eventMetricName).concat(eventDurationLogger_const_1.EVENT_START_SUFFIX));
        performance.clearMarks("".concat(eventMetricName).concat(eventDurationLogger_const_1.EVENT_END_SUFFIX));
    }
    catch (error) {
        __1.logger.emitWarn("".concat(eventMetricName, " - ").concat(eventDurationLogger_const_1.ERROR_EVENT_ERROR_PREFIX, ", ").concat(error));
    }
};
exports.logEventDurationMetric = logEventDurationMetric;
